import {Injectable} from '@angular/core';
import {BaseApiService} from '../common/base-api.service';
import {HttpClient} from '@angular/common/http';
import {SettingsProviderService} from '../common/settings-provider.service';
import {Observable, of} from 'rxjs';
import {IDocumentType} from '../message-models/document-type.interface';
import {CachedData} from '../common/cached-data.class';
import {DocumentEntityType} from '../message-models/document-entity-type.enum';
import {switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService extends BaseApiService {
  documentTypeData: CachedData<IDocumentType> = new CachedData<IDocumentType>([], 100000);

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'DocumentType');
  }

  getAllDocumentTypes(): Observable<IDocumentType[]> {
    if (this.documentTypeData && this.documentTypeData.isDataFresh()) {
      return of(this.documentTypeData.data);
    } else {
      const observedResult = this.post<IDocumentType[]>('GetAllDocumentTypes');
      observedResult.subscribe(
        {
          next: results => {
            this.documentTypeData.clear();
            results.forEach(r => {
              this.documentTypeData.addData(r);
            })
          }
        });
      return observedResult;
    }
  }

  getAllDocumentTypesForEntityType(documentEntityType: DocumentEntityType): Observable<IDocumentType[]> {
    //TODO Not sure about this. when adding new document type..
    return this.post<IDocumentType[]>('GetAllDocumentTypesForEntityType', {documentEntityType});
    // if (this.documentTypeData && this.documentTypeData.isDataFresh()) {
    //   return of(this.documentTypeData.data.filter(dt => dt.documentEntityType === documentEntityType));
    // } else {
    //   return this.getAllDocumentTypes().pipe(switchMap(allDocumentTypes => {
    //     return of(allDocumentTypes.filter(dt => dt.documentEntityType === documentEntityType));
    //   }));
    // }
  }

}
